// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PropertyAgentFullPage {
  display: flex;
  flex-direction: column;
  /*font-size: 1.0em;*/
  font-size: 0.7em;
  font-family: sans-serif;
  /*width: auto;*/
  text-align: left;
  background-color: #fff;
}
.psl-override-header-color {
  background-color: #ddd !important;
}
.psl-selected {
  background-color: #d6e3ff;
}

.PropertyAgentFullPage .psl-table-wrapper {
}

.PropertyAgentFullPage .psl-cell {
  display: flex;
  flex-direction: row;
}

.PropertyAgentFullPage .psl-column {
  font-size: 0.7em;
}
.psl-cell {
}

.psl-column {
  text-align: center;
  border: 1px solid white;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
  padding-top: 0.4em;
}

.psl-select {
  min-width: 2em;
  max-width: 2em;
}
.psl-map {
}
.psl-gallery {
}
.psl-mls {
  min-width: 6em;
  max-width: 6em;
}
.psl-mls a:hover, a:visited, a:active {
  color: blue;
}
.psl-status {
  min-width: 3em;
  max-width: 3em;
}
.psl-expired {
  color: red;
}
.psl-withdrawn {
  color: black;
}
.psl-sold {
  color: blue;
}
.psl-active {
  color: green;
}
.psl-inc {
  min-width: 2em;
  max-width: 2em;
}
.psl-price {
  min-width: 8em;
  max-width: 8em;
}
.psl-type {
  min-width: 8em;
  max-width: 8em;
}
.psl-subtype {
  min-width: 8em;
  max-width: 8em;

}
.psl-addr {
  min-width: 18em;
  max-width: 18em;
}
.psl-town {
  min-width: 14em;
  max-width: 14em;
}
.psl-sqft {
  min-width: 4em;
  max-width: 4em;
}
.psl-lotsz {
  min-width: 5em;
  max-width: 5em;
}

.psl-br {
  min-width: 2.4em;
  max-width: 2.4em;
}
.psl-fb {
  min-width: 2em;
  max-width: 2em;
}
.psl-hb {
  min-width: 2em;
  max-width: 2em;
}
.psl-year {
  min-width: 4em;
  max-width: 4em;
}
.psl-dom {
  min-width: 4em;
  max-width: 4em;
}

.psl-invis-img {
  opacity: 0;
}
.fancy-image-gallery-wrapper {
  position: absolute;
  top: 0px;
  left: 0px;
  margin-top: 2em;
  text-align: center;
  z-index: 101;
}
.psl-backdrop {
  position: absolute !important;
  top: 0px;
  left: -4000em;
  background-color: black;
  opacity: 0.8;
  width: 90000em;
  height: 90000em;
  z-index: 100;
}

.error {
  color: red;
  padding: 0.2em;
}
.psl-button-no-border {
  border: none;
}
.PropertyAgentFullPage .pafp-header-info {
  display: flex;
  flex-direction: column;
  padding-bottom: 1em;
  padding-top: 0.5em;
}
.PropertyAgentFullPage .pafp-spaced-out {
  display: flex;
  flex-direction: row;
}
.PropertyAgentFullPage .pafp-spaced-out div {
  width: 35%;
  border: 1px solid #ccc;
}
.PropertyAgentFullPage .pafp-spaced-out div > b {
}
.PropertyAgentFullPage .pafp-spaced-out div > u {
  padding-left: 1em;
}
.PropertyAgentFullPage .pafp-expired {
  color: red;
}
.PropertyAgentFullPage .pafp-withdrawn {
  color: red;
}
.PropertyAgentFullPage .pafp-sold {
  color: red;
}
.PropertyAgentFullPage .pafp-active {
  color: green;

}
.pafp-pd-label {
  width: 10em;
}
.pafp-pd-value {
  width: 10em;
  font-weight: bolder;

}

.pafp-hdr-label {
  width: 6em;
  font-weight: bold;
}
.pafp-hdr-label-slim {
  width: 4em;
  text-align: end;
  font-weight: bold;
}
.pafp-hdr-value {
  width: 10em;
  text-align: start;
}
.pafp-hdr-value-slim {
  text-align: start;
  padding-left: 0.6em;
}
.pafp-street {
}
.pafp-left-right-split {
  display: flex;
  flex-direction: row;
}
.pafp-img-gallery {
  padding: 0em 1em;
}
.pafp-section-title {
  background-color: #eee;
  color: black;
  font-weight: bolder;
  text-align: center;
  border-bottom: 1px solid black;
}
.pafp-border-bottom {
  border-bottom: 2px solid black;
}
.pafp-checkbox {
  border: 1px solid black !important;
  width: 1em !important;
  height: 1em !important;
  position: relative !important;
  top: 0.4em;
}
.pafp-pager-btn-selected {
  background-color: green;
  color: white;
}
.pafp-selectable-section {
  text-align: center;
}
.pafp-pager-btn-active {
  border: 2px solid blue;
  background-color: blue;
  color: white;
}
.pafp-fimg-hidden {
  display: none !important;
}
.pafp-fimg-show {
  display: block;
}
.pafp-floating-img-gallery {
  position: absolute;
  top: 4em;
  left: 20%;
  width: 60%;
  height: 60%;
  z-index: 10000;
  background-color: white;
  padding: 1em;
}
.pafp-fimg-close-button {
  background-color: red;
  color: white;
  z-index: 10001;
  height: 2em;
  z-index: 20000;
}
.pafp-img-backdrop {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 9999;
  background-color: black;
  opacity: 0.8;
  width: 100%;
  height: 100%;
}
.pafp-img-gallery-no-images {
  padding: 3em 2em;
}
.PropertyAgentFullPage .share-button-generic {
  border: 1px solid black;
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 11px;
  color: black;
  padding-top: 0.8em;
}
.pafp-checkbox {
  margin: 0.4em;
  margin-top: 1em;
  -webkit-appearance: auto !important;
}
.pafp-error-message {
  color: red;
  font-size: 2em;
}
`, "",{"version":3,"sources":["webpack://./src/PropertyAgentFullPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;AACA;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;AACA;AACA;AACA;AACA;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;;AAEhB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,sBAAsB;AACxB;AACA;AACA;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;;AAEd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;;AAErB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;AACA;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,UAAU;EACV,cAAc;AAChB","sourcesContent":[".PropertyAgentFullPage {\n  display: flex;\n  flex-direction: column;\n  /*font-size: 1.0em;*/\n  font-size: 0.7em;\n  font-family: sans-serif;\n  /*width: auto;*/\n  text-align: left;\n  background-color: #fff;\n}\n.psl-override-header-color {\n  background-color: #ddd !important;\n}\n.psl-selected {\n  background-color: #d6e3ff;\n}\n\n.PropertyAgentFullPage .psl-table-wrapper {\n}\n\n.PropertyAgentFullPage .psl-cell {\n  display: flex;\n  flex-direction: row;\n}\n\n.PropertyAgentFullPage .psl-column {\n  font-size: 0.7em;\n}\n.psl-cell {\n}\n\n.psl-column {\n  text-align: center;\n  border: 1px solid white;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  white-space: normal;\n  padding-top: 0.4em;\n}\n\n.psl-select {\n  min-width: 2em;\n  max-width: 2em;\n}\n.psl-map {\n}\n.psl-gallery {\n}\n.psl-mls {\n  min-width: 6em;\n  max-width: 6em;\n}\n.psl-mls a:hover, a:visited, a:active {\n  color: blue;\n}\n.psl-status {\n  min-width: 3em;\n  max-width: 3em;\n}\n.psl-expired {\n  color: red;\n}\n.psl-withdrawn {\n  color: black;\n}\n.psl-sold {\n  color: blue;\n}\n.psl-active {\n  color: green;\n}\n.psl-inc {\n  min-width: 2em;\n  max-width: 2em;\n}\n.psl-price {\n  min-width: 8em;\n  max-width: 8em;\n}\n.psl-type {\n  min-width: 8em;\n  max-width: 8em;\n}\n.psl-subtype {\n  min-width: 8em;\n  max-width: 8em;\n\n}\n.psl-addr {\n  min-width: 18em;\n  max-width: 18em;\n}\n.psl-town {\n  min-width: 14em;\n  max-width: 14em;\n}\n.psl-sqft {\n  min-width: 4em;\n  max-width: 4em;\n}\n.psl-lotsz {\n  min-width: 5em;\n  max-width: 5em;\n}\n\n.psl-br {\n  min-width: 2.4em;\n  max-width: 2.4em;\n}\n.psl-fb {\n  min-width: 2em;\n  max-width: 2em;\n}\n.psl-hb {\n  min-width: 2em;\n  max-width: 2em;\n}\n.psl-year {\n  min-width: 4em;\n  max-width: 4em;\n}\n.psl-dom {\n  min-width: 4em;\n  max-width: 4em;\n}\n\n.psl-invis-img {\n  opacity: 0;\n}\n.fancy-image-gallery-wrapper {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  margin-top: 2em;\n  text-align: center;\n  z-index: 101;\n}\n.psl-backdrop {\n  position: absolute !important;\n  top: 0px;\n  left: -4000em;\n  background-color: black;\n  opacity: 0.8;\n  width: 90000em;\n  height: 90000em;\n  z-index: 100;\n}\n\n.error {\n  color: red;\n  padding: 0.2em;\n}\n.psl-button-no-border {\n  border: none;\n}\n.PropertyAgentFullPage .pafp-header-info {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 1em;\n  padding-top: 0.5em;\n}\n.PropertyAgentFullPage .pafp-spaced-out {\n  display: flex;\n  flex-direction: row;\n}\n.PropertyAgentFullPage .pafp-spaced-out div {\n  width: 35%;\n  border: 1px solid #ccc;\n}\n.PropertyAgentFullPage .pafp-spaced-out div > b {\n}\n.PropertyAgentFullPage .pafp-spaced-out div > u {\n  padding-left: 1em;\n}\n.PropertyAgentFullPage .pafp-expired {\n  color: red;\n}\n.PropertyAgentFullPage .pafp-withdrawn {\n  color: red;\n}\n.PropertyAgentFullPage .pafp-sold {\n  color: red;\n}\n.PropertyAgentFullPage .pafp-active {\n  color: green;\n\n}\n.pafp-pd-label {\n  width: 10em;\n}\n.pafp-pd-value {\n  width: 10em;\n  font-weight: bolder;\n\n}\n\n.pafp-hdr-label {\n  width: 6em;\n  font-weight: bold;\n}\n.pafp-hdr-label-slim {\n  width: 4em;\n  text-align: end;\n  font-weight: bold;\n}\n.pafp-hdr-value {\n  width: 10em;\n  text-align: start;\n}\n.pafp-hdr-value-slim {\n  text-align: start;\n  padding-left: 0.6em;\n}\n.pafp-street {\n}\n.pafp-left-right-split {\n  display: flex;\n  flex-direction: row;\n}\n.pafp-img-gallery {\n  padding: 0em 1em;\n}\n.pafp-section-title {\n  background-color: #eee;\n  color: black;\n  font-weight: bolder;\n  text-align: center;\n  border-bottom: 1px solid black;\n}\n.pafp-border-bottom {\n  border-bottom: 2px solid black;\n}\n.pafp-checkbox {\n  border: 1px solid black !important;\n  width: 1em !important;\n  height: 1em !important;\n  position: relative !important;\n  top: 0.4em;\n}\n.pafp-pager-btn-selected {\n  background-color: green;\n  color: white;\n}\n.pafp-selectable-section {\n  text-align: center;\n}\n.pafp-pager-btn-active {\n  border: 2px solid blue;\n  background-color: blue;\n  color: white;\n}\n.pafp-fimg-hidden {\n  display: none !important;\n}\n.pafp-fimg-show {\n  display: block;\n}\n.pafp-floating-img-gallery {\n  position: absolute;\n  top: 4em;\n  left: 20%;\n  width: 60%;\n  height: 60%;\n  z-index: 10000;\n  background-color: white;\n  padding: 1em;\n}\n.pafp-fimg-close-button {\n  background-color: red;\n  color: white;\n  z-index: 10001;\n  height: 2em;\n  z-index: 20000;\n}\n.pafp-img-backdrop {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  z-index: 9999;\n  background-color: black;\n  opacity: 0.8;\n  width: 100%;\n  height: 100%;\n}\n.pafp-img-gallery-no-images {\n  padding: 3em 2em;\n}\n.PropertyAgentFullPage .share-button-generic {\n  border: 1px solid black;\n  font-family: Roboto, sans-serif;\n  font-weight: 500;\n  font-size: 11px;\n  color: black;\n  padding-top: 0.8em;\n}\n.pafp-checkbox {\n  margin: 0.4em;\n  margin-top: 1em;\n  -webkit-appearance: auto !important;\n}\n.pafp-error-message {\n  color: red;\n  font-size: 2em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
